import axios from "axios";

import { BASE_URL } from "src/shared/model";

export const axiosInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  try {
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("Failed to inject auth header", e);
  }

  return config;
});
